import { ApplicationRef, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { rootReducer } from 'TargetRatesApp/apps/target-rates-app/target-rates.store';

import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { SimpleFundChartModule } from 'ChartApp/ts/features/simple-fund-chart/simple-fund-chart.module';
import { YieldCurveModule } from 'TargetRatesApp/features/yield-curve-component/yield-curve.module';

import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { IntradaysRatesComponent } from 'TargetRatesApp/features/intradays-rates-component/intradays-rates.component';
import { KeyRatesComponent } from 'TargetRatesApp/features/key-rates-component/key-rates.component';
import { YieldCurveComponent } from 'TargetRatesApp/features/yield-curve-component/yield-curve.component';

import { getLogger } from 'Angular/state/logger';

@NgModule({
    declarations: [IntradaysRatesComponent, KeyRatesComponent],
    imports: [
        BrowserModule,
        ConfigModule,
        NavigationModule,
        SimpleFundChartModule,
        FormsModule,
        YieldCurveModule,
        RouterModule.forRoot([{ path: 'yield_curve', component: YieldCurveComponent }]),
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() }),
    ],
    exports: [IntradaysRatesComponent, KeyRatesComponent],
})
export class AppModule {
    ngDoBootstrap(appRef: ApplicationRef): void {
        appRef.bootstrap(IntradaysRatesComponent);
        appRef.bootstrap(KeyRatesComponent);
        appRef.bootstrap(YieldCurveComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
    }
}
